import React, { createContext, useCallback, useState } from 'react'

import { Modal } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import useSchoolPeriod from '../../../utils/api/hooks/useSchoolPeriod'
import { isObject } from '../../../utils'
import SchoolPeriodForm from './SchoolPeriodForm'
import { getUser } from '../../../reducers/UserReducer'
import { UpdateModes } from '../../../utils/enums/enums'
import { Actions } from '../../../utils/events'

export const SchoolPeriodFormModalContext = createContext()

const DEFAULT_FORM_HANDLER = { data: null, callback: null }

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const SchoolPeriodFormModalProvider = ({ children, mode = UpdateModes.OPTIMISTIC, user, t }) => {
  const [formHandler, setFormHandler] = useState(DEFAULT_FORM_HANDLER)
  const [isLoading, setIsLoading] = useState(false)

  const periodHandler = useSchoolPeriod({ user, t, mode, callback: formHandler.callback })

  const handleSubmit = useCallback(schoolPeriod => {
    setIsLoading(true)
    periodHandler.upsert(schoolPeriod, formHandler.data).finally(handleCloseModal)
  }, [periodHandler.upsert])

  const handleDelete = useCallback(() => {
    setIsLoading(true)
    periodHandler.delete(formHandler.data).finally(handleCloseModal)
  }, [formHandler.data, periodHandler.delete])

  const handleCloseModal = useCallback(() => setFormHandler(DEFAULT_FORM_HANDLER), [])

  const action = formHandler.data?.id === -1 ? Actions.CREATE.toLocaleLowerCase() : Actions.UPDATE.toLocaleLowerCase()

  return (
    <>
      <SchoolPeriodFormModalContext.Provider value={{ setFormHandler }}>
        {children}
      </SchoolPeriodFormModalContext.Provider>
      <Modal
        className='form-modal-without-footer'
        title={t(`school_period_modal.title.${action}`)}
        visible={isObject(formHandler.data)}
        destroyOnClose
        footer={null}
        onCancel={handleCloseModal}
        afterClose={() => setIsLoading(false)}
      >
        {isObject(formHandler.data) && (
          <SchoolPeriodForm
            data={formHandler.data}
            disabled={isLoading}
            onSubmit={handleSubmit}
            onDelete={handleDelete}
            onCancel={handleCloseModal}
          />
        )}
      </Modal>
    </>
  )
}

export default connect(mapStateToProps)(SchoolPeriodFormModalProvider)
